import http from './http'
import authHeader from './authHeader'

const postLogin = ({ email, password }) => {
	console.log(http)

	return http.post('login', { email, password })
}

const postPKI = ({ data }) => {
	return http.post('login/pki', { data })
}

const postLoginUrl = ({ token }) => {
	return http.post(
		'ebolashak/v2/user/auth/url/login',
		{ token },
		{ headers: authHeader() }
	)
}

const recoverByEmail = ({ email }) => {
	return http.post('login/forgot', { email }, { headers: authHeader() })
}
const recoverByToken = ({ token, password }) => {
	return http.post('login/forgot/code', { token, password })
}
// все
const getUser = () => {
	return http.get(`user`, { headers: authHeader() })
}
// (эксперт, админ)
const getThisUser = id => {
	return http.get(`user/${id}`, { headers: authHeader() })
}
// (эксперт, админ)
const getThisUserCompetition = id => {
	return http.get(`user/${id}/competition`, { headers: authHeader() })
}
// (эксперт, админ)
const getThisUserJob = id => {
	return http.get(`user/${id}/job/list`, { headers: authHeader() })
}

// (админ)
// #### Request (GET) /api/v1/user/search
// - email (optional)
const getUserSearch = mail => {
	return http.get(`user/search/`, { mail }, { headers: authHeader() })
}

// все
const changePassword = ({ password_current, password_new }) => {
	return http.post(
		'password/change',
		{ password_current, password_new },
		{ headers: authHeader() }
	)
}
// все
const changeEmail = email => {
	return http.post('email/change', { email }, { headers: authHeader() })
}
// претендент
const download = () => {
	return http.get('resume', { headers: authHeader() })
}
// претендент
const job = () => {
	return http.get('job/list', { headers: authHeader() })
}

const UserService = {
	postLogin,
	postPKI,
	postLoginUrl,
	recoverByEmail,
	recoverByToken,
	getUser,
	getThisUser,
	getThisUserCompetition,
	getThisUserJob,
	getUserSearch,
	changePassword,
	changeEmail,
	download,
	job,
}
export default UserService
